import { render, staticRenderFns } from "./creditbank.vue?vue&type=template&id=0fad6529"
import script from "./creditbank.vue?vue&type=script&lang=js"
export * from "./creditbank.vue?vue&type=script&lang=js"
import style0 from "./creditbank.vue?vue&type=style&index=0&id=0fad6529&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports